import * as S from './inoutWrapper.styles';
import { InputWrapperProps } from './inputWrapper.interface';

const InputWrapper = ({ children }: InputWrapperProps) => <S.Wrapper>{children}</S.Wrapper>;

export default InputWrapper;
